import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class AdapterService {
  public transform<T>(dto: any, callback: (value: any) => T): T {
    return callback(dto);
  }
}
